export default __webpack_public_path__ + "static/media/app_bg.d8a1fbb4.png";